<template>
	<div class="contact-form">
        <p>Contact</p>
        <form method="POST" action="">
            <div class="item"> 
                <label for="name">Naam</label>
                <input type="text" id="name" name="name"></input>
            </div>
            <div class="item"> 
                <label for="email">E-mail</label>
                <input type="text" id="email" name="email"></input>
            </div>
            <div class="item"> 
                <label for="telefoon">Telefoon</label>
                <input type="text" id="telefoon" name="telefoon"></input>
            </div>
            <div class="item"> 
                <label for="bericht">Bericht</label>
                <textarea id="bericht" name="bericht"></textarea>
            </div>
            <div class="item">
                <input type="checkbox" name="nieuwsbrief" id="newsletter" style="width: 20px; height: 12pt; margin:0;" />
                <label for="newsletter" style="width: 400px; text-align: left;">Ik wil me aanmelden voor de nieuwsbrief</label>
            </div>
            <button type="submit">Verstuur</button>
        </form>
	</div>
</template>

<script>
export default {
	name: 'contact-form',
	data() {
		return {
		};
	},
	computed: {
	},
	methods: {
	}
};
</script>

<style lang="less">
@import "../styles/styles.less";

button, input, select, textarea {
    font-family: inherit;
    font-size: 100%;
    box-sizing: border-box;
}
.contact-form {
    background: @blue-3;
    border-radius: 5px;
    margin: 0 50px;
    padding: 20px;
    color: white;
    text-align: center;
}

.contact-form p {
    color: white;
}

.item {
    margin: 5px;
}

.item label {
    display: inline-block;
    width: 100px;
}

.item input {
    margin-right: 100px;
    height: 35px;
    width: 500px;
    
}

.item textarea {
    margin-right: 100px;
    height: 70px;
    width: 500px;
    resize: none;
}

button {
    width: 400px;
    height: 40px;
    background: @light-blue-1;
    border-radius: 5px;
    border: 2px solid @light-blue-1;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/ContactForm.vue